<form [formGroup]="metadataFormGroup">
  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Date de début</label>
      <input type="date" class="form-control" formControlName="startDate" />
    </div>
    <div class="col">
      <label i18n>Durée du contrat</label>
      <input
        type="text"
        class="form-control"
        formControlName="contractDuration"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Mode de paiement</label>
      <select class="form-control" formControlName="paymentFrequency">
        <option [value]="null" i18n>Sélectionner</option>
        <option *ngFor="let value of paymentFrequencyValues" [value]="value">
          {{ getPaymentFrequencyLabel(value) }}
        </option>
      </select>
    </div>
    <div class="col">
      <label i18n>Supplément pour paiement fractionné en %</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="splitPaymentFee"
      />
    </div>
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Genre de police</label>
      <select class="form-control" formControlName="policyType">
        <option *ngFor="let value of policyTypeValues" [value]="value">
          {{ getBusinessTransportPolicyTypeLabel(value) }}
        </option>
      </select>
    </div>
    <div class="col">
      <label i18n>Franchise par cas</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="deductibleByCase"
      />
    </div>
  </div>

  <div class="row my-3">
    <div class="col">
      <label i18n>Couverture d'assurance</label>
      <textarea
        class="form-control"
        rows="3"
        formControlName="coverages"
      ></textarea>
    </div>
  </div>

  <div class="row my-3">
    <div class="col">
      <label i18n>Limitations</label>
      <textarea
        class="form-control"
        rows="3"
        formControlName="limitations"
      ></textarea>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Sommes d'assurance et moyen de transport
  </div>
  <div formGroupName="insuranceSumByMeans">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Par chemin de fer</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuranceSumRailroad"
        />
      </div>
      <div class="col">
        <label i18n>Par véhicule routier de camionneur professionel</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuranceSumTruck"
        />
      </div>
    </div>

    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Par avion</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuranceSumPlane"
        />
      </div>
      <div class="col">
        <label i18n>Par navire</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuranceSumBoat"
        />
      </div>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Envois postaux à l'intérieur de la Suisse et du Liechtenstein
  </div>
  <div formGroupName="insuranceSumLocal">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n
          >Par colis postal avec prestation complémentaire "Signature"</label
        >
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuranceSumParcelSignature"
        />
      </div>
      <div class="col">
        <label i18n>Par lettre "Recommandée"</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuranceSumRegistedLetter"
        />
      </div>
    </div>

    <div class="row row-cols-md-1 my-3">
      <div class="col">
        <label i18n>SecurePost, par colis</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuranceSumSecurePost"
        />
      </div>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Envois postaux à destination/ en provenance de l'étranger
  </div>
  <div formGroupName="insuranceSumInternational">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Par colis "PRIORITY / ECONOMY"</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuranceSumParcel"
        />
      </div>
      <div class="col">
        <label i18n>Par lettre "Recommandée"</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuranceSumRegistedLetter"
        />
      </div>
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Envois par service de courrier, express et service de paquets postaux
  </div>
  <div formGroupName="insuranceSumPostal">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Par colis</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuranceSumParcel"
        />
      </div>
      <div class="col">
        <label i18n
          >Envois pour l’ensemble des marchandises pouvant se trouver en même
          temps</label
        >
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuranceSumMerchandise"
        />
      </div>
    </div>
  </div>
</form>
